import { render, staticRenderFns } from "./my-shezhi.vue?vue&type=template&id=0a3495bd&scoped=true&"
import script from "./my-shezhi.vue?vue&type=script&lang=js&"
export * from "./my-shezhi.vue?vue&type=script&lang=js&"
import style0 from "./my-shezhi.vue?vue&type=style&index=0&id=0a3495bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3495bd",
  null
  
)

export default component.exports